import slugify from './slugify';


export const findSectionForPath = (
  pathname,
  sections
) => {
  let activeSection;
  const slugId = pathname.split('/').slice(-1)[0];

  sections.forEach(section => {
    const match = section.items && section.items.some(
      item =>
        slugId === slugify(item.id)
    );
    if (match) {
      activeSection = section;
    }
  });

  return activeSection;
};

